module.exports = __webpack_public_path__ + "media/images/icons/search-icon-155bf668695b49ea1d6eadb87218424e.svg";